/*
Usage: memberNav.js
---
import memberNav from './lib/memberNav'
memberNav()

機能:
- ハンバーガーボタンで body に --member-nav-open を toggle（モバイル）
- オーバーレイクリックでナビを閉じる
- サブメニュートグル（課題メニュー等）
*/

const memberNav = () => {
  const hamburger = document.querySelector(".js-member-nav");
  const overlay = document.querySelector(".js-member-nav-overlay");
  const body = document.body;

  if (!hamburger) return;

  // ハンバーガー toggle
  hamburger.addEventListener("click", () => {
    const isOpen = body.classList.toggle("--member-nav-open");
    hamburger.setAttribute("aria-expanded", isOpen);
  });

  // オーバーレイクリックで閉じる
  if (overlay) {
    overlay.addEventListener("click", () => {
      body.classList.remove("--member-nav-open");
      hamburger.setAttribute("aria-expanded", "false");
    });
  }

  // サブメニュートグル
  document.querySelectorAll(".member-nav__toggle").forEach((btn) => {
    btn.addEventListener("click", () => {
      const item = btn.closest(".--has-sub");
      if (!item) return;
      const isOpen = item.classList.toggle("--sub-open");
      btn.setAttribute("aria-expanded", isOpen);
    });
  });
};

export { memberNav as default };
